export default function Academics() {
	return (
		<section className="container-gg py-12">
			<h1 className="text-3xl font-bold text-slate-900">Academics</h1>
			<p className="mt-4 max-w-3xl text-slate-700">
				Our teaching team follows an integrated curriculum that meets national standards while layering global best practices, technology, and project-based learning. Students in the day school benefit from flexible schedules and enrichment clusters, while Secondary boarders enjoy extended studio, lab, and study sessions supported by resident tutors.
			</p>
			<div className="mt-8 grid gap-6 md:grid-cols-3">
				<div className="rounded-lg border border-slate-200 p-6">
					<h3 className="font-semibold">Nursery</h3>
					<ul className="mt-2 list-disc pl-5 text-sm text-slate-600">
						<li>Play-based literacy &amp; numeracy</li>
						<li>Montessori-inspired art, music, and sensory labs</li>
						<li>Faith foundations and social skills</li>
					</ul>
				</div>
				<div className="rounded-lg border border-slate-200 p-6">
					<h3 className="font-semibold">Primary</h3>
					<ul className="mt-2 list-disc pl-5 text-sm text-slate-600">
						<li>STEAM projects and coding essentials</li>
						<li>Reader&apos;s &amp; Writer&apos;s Workshop plus French</li>
						<li>Clubs, sports academies, and service learning</li>
					</ul>
				</div>
				<div className="rounded-lg border border-slate-200 p-6">
					<h3 className="font-semibold">Secondary (Day &amp; Boarding)</h3>
					<ul className="mt-2 list-disc pl-5 text-sm text-slate-600">
						<li>STEM, Arts, Business, and Humanities pathways</li>
						<li>IGCSE/WAEC mastery clinics with boarding prep sessions</li>
						<li>Career mentoring, entrepreneurship incubator, and leadership councils</li>
					</ul>
				</div>
			</div>

			<div className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-6">
				<p className="text-sm font-semibold uppercase tracking-wide text-brand">Learning Support &amp; Residence Life</p>
				<p className="mt-3 text-sm text-slate-700">
					Every Secondary boarder is paired with an academic coach to align residence-life routines with classroom goals. Day students can opt into twilight tutorials and boarding-style supervised prep when they need additional support, ensuring every learner thrives regardless of residency choice.
				</p>
			</div>
		</section>
	)
}






